/**
 * @file Footer.tsx
 * @description Shared footer component for all pages
 */

'use client';

import { Link } from '@/i18n/routing';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';

export default function Footer() {
  const t = useTranslations('footer');
  const currentYear = new Date().getFullYear();
  const [isBikeMapka, setIsBikeMapka] = useState(true);

  useEffect(() => {
    const hostname = window.location.hostname;
    const searchParams = new URLSearchParams(window.location.search);
    const domainOverride = searchParams.get('domain');

    if (domainOverride === 'snowpark') {
      setIsBikeMapka(false);
    } else if (domainOverride === 'bikepark') {
      setIsBikeMapka(true);
    } else {
      setIsBikeMapka(hostname.includes('bikeparkmapa.pl') || hostname.includes('localhost'));
    }
  }, []);

  return (
    <footer className="bp-footer">
      <div className="bp-footer-container">
        {/* Main footer content */}
        <div className="bp-footer-grid">
          {/* About section */}
          <div className="bp-footer-section">
            <h3 className="bp-footer-heading">{t('title')}</h3>
            <p className="bp-footer-text">
              {t('description')}
            </p>
          </div>

          {/* Links - Bikeparki */}
          <div className="bp-footer-section">
            <h4 className="bp-footer-heading">{t('bikeparks')}</h4>
            <ul className="bp-footer-links">
              <li><Link href="/bikeparki">{t('map')}</Link></li>
              <li><Link href="/bikeparki/lista">{t('list')}</Link></li>
              <li><Link href="/bikeparki/ranking">{t('ranking')}</Link></li>
              <li><Link href="/pumptracki">{t('pumptracks')}</Link></li>
            </ul>
          </div>

          {/* Links - Rodzaje tras */}
          <div className="bp-footer-section">
            <h4 className="bp-footer-heading">{t('trailTypes')}</h4>
            <ul className="bp-footer-links">
              <li><Link href="/trasy-downhill">{t('downhill')}</Link></li>
              <li><Link href="/trasy-flow">{t('flow')}</Link></li>
              <li><Link href="/trasy-air">{t('air')}</Link></li>
            </ul>
          </div>

          {/* Links - Przewodniki */}
          <div className="bp-footer-section">
            <h4 className="bp-footer-heading">{t('guides')}</h4>
            <ul className="bp-footer-links">
              <li><Link href="/jak-zaczac">{t('gettingStarted')}</Link></li>
              <li><Link href="/przewodnik">{t('guide')}</Link></li>
              <li><Link href="/sprzet">{t('gear')}</Link></li>
            </ul>
          </div>

          {/* Links - O nas */}
          <div className="bp-footer-section">
            <h4 className="bp-footer-heading">{t('about')}</h4>
            <ul className="bp-footer-links">
              <li><Link href="/o-nas">{t('aboutProject')}</Link></li>
              <li><Link href="/blog">{t('blog')}</Link></li>
              <li><Link href="/snowparks">{t('snowparks')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="bp-footer-bottom">
          <p className="bp-footer-copy">
            {t('copyright', { year: currentYear })}
          </p>
          <div className="bp-footer-bottom-links">
            {isBikeMapka ? (
              <a
                href="https://snowparkmap.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bp-footer-link"
              >
                {t('snowparkmap')}
              </a>
            ) : (
              <>
                <a
                  href="https://bikeparkmapa.pl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bp-footer-link"
                >
                  {t('bikeparkmapa')}
                </a>
                <a
                  href="https://bikeparkmapa.pl/pumptracki"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bp-footer-link"
                >
                  {t('pumptracks')}
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
